<template>
  <div class="html-viewer-container">
    <iframe
      ref="htmlIframe"
      class="html-content-frame"
      sandbox="allow-same-origin allow-scripts"
      @load="onIframeLoad"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'HTMLViewer',
  props: {
    source: {
      type: String,
      required: true,
      validator(value) {
        return typeof value === 'string' && value.trim().length > 0
      },
    },
  },
  data() {
    return {}
  },
  watch: {
    source: {
      handler() {
        this.loadHtmlContent()
      },
      immediate: false,
    },
  },
  mounted() {
    this.loadHtmlContent()
  },
  beforeDestroy() {
    this.cleanup()
  },
  methods: {
    cleanup() {
      const iframe = this.$refs.htmlIframe
      if (!iframe) return

      const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document
      if (!iframeDoc || typeof iframeDoc.write !== 'function') return

      iframeDoc.open()
      iframeDoc.write('')
      iframeDoc.close()
    },
    onIframeLoad() {
      const iframe = this.$refs.htmlIframe
      if (!iframe) return

      try {
        const iframeWindow = iframe.contentWindow
        const iframeDoc = iframe.contentDocument || iframeWindow?.document

        if (!iframeDoc) return

        const stopEventPropagation = event => {
          event.preventDefault()
          event.stopPropagation()
        }

        const eventsToIntercept = ['click', 'mousedown', 'mouseup']

        eventsToIntercept.forEach(eventType => {
          iframeDoc.addEventListener(eventType, stopEventPropagation, true)
        })
      } catch (error) {
        console.warn('Cannot access iframe content')
      }
    },
    async loadHtmlContent() {
      if (!this.source || typeof this.source !== 'string') return

      await this.$nextTick()

      const iframe = this.$refs.htmlIframe
      if (!iframe) return

      const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document
      if (!iframeDoc || typeof iframeDoc.write !== 'function') return

      iframeDoc.open()
      iframeDoc.write(this.source)
      iframeDoc.close()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/light-theme-system-palette.scss';

.html-viewer-container {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: $surface-container;
  overflow: hidden;
}
.html-content-frame {
  width: 100%;
  height: 100%;
  border: none;
  background-color: $surface-container;
  flex: 1;
}
</style>
